export function isFirefoxDesktop(): boolean {
    return /Firefox\/\d+/.test(navigator.userAgent) && !/Mobi|Android|iPhone|iPad/.test(navigator.userAgent);
}

export function isMobileDevice(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export function isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export function isAndroid(): boolean {
    return /Android/.test(navigator.userAgent);
}

export function isMetaMaskAppBrowser() {
    const ua = navigator.userAgent || navigator.vendor;

    const isMetaMaskMobile = /MetaMaskMobile/i.test(ua);
    const isMetaMaskInstalled = !!(window.ethereum && window.ethereum.isMetaMask);

    return isMetaMaskInstalled && isMetaMaskMobile;
}
